module.exports = __webpack_public_path__ + "server.c9921105be8d80b5d9ae2a053ea10ea9.svg";